import { UserFollowingIcon } from '@/components/icons/user-following-icon';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useMe } from '@/data/user';
import { API_ENDPOINTS } from '@/data/client/endpoints';
import client from '@/data/client';
import { CloseCircleIcon } from '../icons/close-circle-icon';
import { useTranslation } from 'next-i18next';
import cn from 'classnames';
import { Button } from '@nextui-org/react';
import { useLocalIsFollowedShop } from '@/data/shop';

type FollowButtonProps = {
  shop_id: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
};

const sizeMap = {
  xs: {
    button: 'h-6 px-1',
    icon: 'h-2.5 w-2.5',
  },
  sm: {
    button: 'h-9 px-3',
    icon: 'h-[15px] w-[15px]',
  },
  md: {
    button: 'h-11 px-4',
    icon: 'h-4 w-4',
  },
  lg: {
    button: 'h-12 px-5',
    icon: 'h-5 w-5',
  },
};

export default function FollowButton({ shop_id, size = 'md' }: FollowButtonProps) {
  const queryClient = useQueryClient();
  const { isAuthorized, isLoading: isLoadingMe, me } = useMe();
  const isShopFollowed = useLocalIsFollowedShop(shop_id);

  const { mutate: toggleFollow } = useMutation(client.follow.toggle, {
    onSettled: () => {
      queryClient.invalidateQueries([API_ENDPOINTS.FOLLOW_SHOP, shop_id]);
      queryClient.invalidateQueries([API_ENDPOINTS.FOLLOWED_SHOPS]);
    },
  });

  function handleToggleFollow() {
    toggleFollow({
      shop_id,
    });
  }
  const { t } = useTranslation('common');
  
  return (
    <>
      {isAuthorized && me && !isLoadingMe && (
        <Button
          onClick={handleToggleFollow}
          variant={isShopFollowed ? 'solid' : 'bordered'}
          color={isShopFollowed ? 'primary' : 'primary'}
          className={cn(
            'followButton rounded-md text-xs border-1',
            sizeMap[size].button,
            !isShopFollowed && 'text-brand dark:text-brand'
          )}
          
        >
          {isShopFollowed ? (
            <>
              <CloseCircleIcon className={cn('text-current', sizeMap[size].icon)} />
              Following
            </>
          ) : (
            <>
              <UserFollowingIcon className={cn('text-current', sizeMap[size].icon)} />
              {t('text-follow')}
            </>
          )}
        </Button>
      )}
    </>
  );
}
